export default function initBackgroundVideo(fragmentElement) {
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const handleVideoAutoplay = ($video, shouldPlay) => {
        if (!$video) return;

        const isReduced = prefersReducedMotion();

        if (isReduced) {
            $video.removeAttribute('autoplay');
            $video.removeAttribute('preload');
            $video.pause?.();
            return;
        }

        if (!shouldPlay) return;

        $video.muted = true;
        $video.setAttribute('autoplay', '');
        $video.setAttribute('preload', 'auto');
        $video.setAttribute('playsinline', '');

        const playPromise = $video.play?.();
        if (playPromise !== undefined) {
            playPromise.catch(err => {
                console.warn('Autoplay failed:', err);
            });
        }
    };

    window.addEventListener('load', function () {
        document.querySelectorAll('.card-background-video-desktop').forEach($video => {
            if ($video && window.innerWidth >= 1024) {
                handleVideoAutoplay($video, true);
            }
        });

        document.querySelectorAll('.card-background-video-mobile').forEach($video => {
            if ($video && window.innerWidth >= 769 && window.innerWidth < 1024) {
                handleVideoAutoplay($video, true);
            }
        });

        document.querySelectorAll('.card-background-video-tablet').forEach($video => {
            if ($video && window.innerWidth < 769) {
                handleVideoAutoplay($video, true);
            }
        });

        document.querySelectorAll('.slider-hero-background-video-desktop').forEach($video => {
            handleVideoAutoplay($video, window.innerWidth >= 1024);
        });

        document.querySelectorAll('.hero-background-video-tablet').forEach($video => {
            handleVideoAutoplay($video, window.innerWidth >= 769 && window.innerWidth < 1024);
        });

        document.querySelectorAll('.hero-background-video-mobile').forEach($video => {
            handleVideoAutoplay($video, window.innerWidth < 769);
        });
    });
}
